export const PREGNANCY_DURATION_DAYS = 280; 
export const DAYS_PER_WEEK = 7;
export const MAX_PREGNANCY_WEEKS = 42;